/**
 * Created by claudio iozzia on 16/05/2017.
 */

import {Utils, tassign} from "../../common/utils";
import {ApplicationSpecActions} from "../Actions/application-spec-actions";
import {APP_SPEC_STATE_INIT, IAppSpec} from "../selector.state";
import {ILedParam, ISingleOutput, ISpec} from "../../models/ISpec";
import {SPEC_VALUE_LED_INIT, SPEC_VALUE_OUTPUTS_INIT} from "../../models/Spec_States";
import {FeatureFilterState} from "../../models/features/feature_const";


function getTotalOutput(outputs: ISingleOutput<number>[], leds: ILedParam<number>): ISingleOutput<number> {
  const ret: ISingleOutput<number> = outputs.reduce((acc: ISingleOutput<number>, curr) => {
      const _voltage_curr = Utils.isValueReal(curr.voltage) ? (Math.abs(curr.voltage)) * leds.serial : null;
      const _current_curr = Utils.isValueReal(curr.current) ? (Math.abs(curr.current)) * leds.parallel : null;
      return {
        voltage: Utils.isValueReal(_voltage_curr) ? acc.voltage + _voltage_curr : acc.voltage,
        current: Utils.isValueReal(_current_curr) ? acc.current + _current_curr : acc.current,
        power: (Utils.isValueReal(_voltage_curr) && Utils.isValueReal(_current_curr) ? acc.power + _voltage_curr * _current_curr : acc.power )
      };
    }
    , {voltage: null, current: null, power: null});
  return ret;
}

function getSingleOutput(out: ISingleOutput<number>): ISingleOutput<number> {
  const _outputValue: ISingleOutput<number> = {
    voltage: out.voltage,
    current: out.current,
    power: (Utils.isValueReal(out.voltage) && Utils.isValueReal(out.current) ? Math.abs(out.voltage) * out.current : NaN)
  };

  return _outputValue;
}

export function applicationSpecValueReducer(state: ISpec<number>, action: any): ISpec<number> {
  switch (action.type) {
    case ApplicationSpecActions.ActionType.INPUT_SET_VALUE:
      return tassign(state, {input: action.payload});
    case ApplicationSpecActions.ActionType.OUTPUT_ADD:
      const _outputs: ISingleOutput<number>[] = [...state.output.outputs, SPEC_VALUE_OUTPUTS_INIT];
      return tassign(state, {
        output: {
          outputs: _outputs,
          globalOutput: getTotalOutput(_outputs, state.output.ledParam),
          ledParam: state.output.ledParam
        }
      });
    case ApplicationSpecActions.ActionType.OUTPUT_REMOVE:
      // the first output couldn't never removed
      const _outputs1: ISingleOutput<number>[] = state.output.outputs.filter((x, i) => !(i > 0 && i === action.payload));
      return tassign(state, {
        output: {
          outputs: _outputs1,
          globalOutput: getTotalOutput(_outputs1, SPEC_VALUE_LED_INIT),
          ledParam: state.output.ledParam
        }
      });
    case ApplicationSpecActions.ActionType.SINGLE_OUTPUT_SET_VALUE:
      const _outputs2: ISingleOutput<number>[] = state.output.outputs.map((x, i) => (i === action.payload.index) ? getSingleOutput(x) : x);
      // console.log("TesT _output2", _outputs2);
      return tassign(state, {
        output: {
          outputs: _outputs2,
          globalOutput: getTotalOutput(_outputs2, state.output.ledParam),
          ledParam: state.output.ledParam
        }
      });
    case ApplicationSpecActions.ActionType.OUTPUT_SET_VALUE:
      const _outputs3: ISingleOutput<number>[] = action.payload.outputs.map((x) => getSingleOutput(x));
      const _ledParam: ILedParam<number> = {
        serial: action.payload.ledParam.serial,
        parallel: action.payload.ledParam.parallel,
        rd: action.payload.ledParam.rd,
        selectedLed: state.output.ledParam.selectedLed
      };
      // console.log("TesT _output3", _outputs3);
      return tassign(state, {
        output: {
          outputs: _outputs3,
          globalOutput: getTotalOutput(_outputs3, _ledParam),
          ledParam: _ledParam
        }
      });
    case ApplicationSpecActions.ActionType.SELECT_LED:
      return tassign(state, {
        output: tassign(state.output, {
          outputs: state.output.outputs,
          globalOutput: state.output.globalOutput,
          ledParam: tassign(state.output.ledParam, {selectedLed: action.payload})
        })
      });
    default:
      return state;
  }
}

export function applicationSpecReducer(state: IAppSpec = APP_SPEC_STATE_INIT, action: any): IAppSpec {
  switch (action.type) {
    case ApplicationSpecActions.ActionType.RESET_SPECS:
      return tassign(APP_SPEC_STATE_INIT, {featuresFilter: state.featuresFilter.map(x => tassign(x, {stateFilter: x.isCommon ? x.stateFilter : FeatureFilterState.NO_FILTER}))});
    case ApplicationSpecActions.ActionType.UPDATE_OUTPUTS_BOUNDS:
      return tassign(state, {outputBounds: action.payload});
    case ApplicationSpecActions.ActionType.SET_FEATURES_FILTER:
      return tassign(state, {featuresFilter: action.payload});
    case ApplicationSpecActions.ActionType.UPDATE_FEATURE_FILTER:
      return tassign(state,
        {featuresFilter: state.featuresFilter.map((x) => (x.key !== action.payload.key) ? x : action.payload)});
    case ApplicationSpecActions.ActionType.SET_NOTES:
      return tassign(state, {
        noteGlobal: action.payload.globalNote,
        spec: {value: state.spec.value, note: action.payload.note}
      });
    case ApplicationSpecActions.ActionType.EDIT_SPEC:
      return tassign(state, {specEdited: action.payload});
    default:
      return tassign(state, {
        spec: {
          value: applicationSpecValueReducer(state.spec.value, action),
          note: state.spec.note
        }
      });
  }
}
